import React, {Component} from "react";
import FeatherIcon from 'feather-icons-react';
import FooterView from "../components/layout/FooterView";

class Footer extends Component{

    render(){
        if (process.env.REACT_APP_LEGACY_LAYOUT !== "true") return <FooterView />;
        return(
        
          <div className="text-center fixed-bottom bg-white pb-2">
              <p className="mb-0 small">&copy; <span className="fw-bolder me-3"> {new Date()?.getFullYear()} { process.env.REACT_APP_NAME }</span>  
              Made <FeatherIcon icon={"heart"} className="text-danger"></FeatherIcon> by <a className="text-decoration-none ms-1" href="https://evivesoma.net" target="_blank" rel="noreferrer">EviveSoma</a>
              <span className="mx-1">·</span>
              <a className="text-decoration-none" href="https://evivedigital.net" target="_blank" rel="noreferrer">EviveDigital</a></p>
          </div>
   
        )
    }
}
export default Footer;
